import { Components } from '@formio/js';
import { ApplicationRef, ComponentRef, createComponent } from '@angular/core';
import { PdfUploadMultipleComponent } from './pdf-upload-multiple.component';
import { environmentInjector } from '../../../shared/formio-environment';

const Field = (Components as any).components.field;

export class PdfUploadMultipleFormioComponent extends Field {
    constructor(...args: any[]) {
        super(...args);
    }

    static schema(...extend) {
        return Field.schema({
            type: 'pdfUploadMultiple',
            label: 'Arquivos PDF',
            key: 'pdfUploadMultiple',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Arquivos PDF',
            selector: 'pdf-upload-multiple',
            icon: 'file-circle-plus',
            group: 'basic',
            fieldOptions: ['maxFiles'],
            schema: PdfUploadMultipleFormioComponent.schema(),
        };
    }

    angularRef?: ComponentRef<PdfUploadMultipleComponent>;

    // Renders an empty host for Angular to mount into
    render(children) {
        return super.render(`<div class="formio-angular-host"></div>`);
    }

    attach(element) {
        const result = super.attach(element);

        const host = element.querySelector('.formio-angular-host');
        if (!host) return result;

        if (!environmentInjector) {
            console.warn('No EnvironmentInjector found');
            return result;
        }

        this.angularRef = createComponent(PdfUploadMultipleComponent, {
            environmentInjector: environmentInjector,
            hostElement: host
        });

        Object.assign(this.angularRef.instance, {
            maxFiles: this.component.maxFiles,
            disabled: this.disabled,
            value: this.dataValue
        });

        this.angularRef.instance._value = this.dataValue;
        this.angularRef.instance._valueChange.subscribe((val) => this.setValue(val, {}));

        const appRef = environmentInjector.get(ApplicationRef);
        appRef.attachView(this.angularRef.hostView);

        this.on('destroy', () => {
            appRef.detachView(this.angularRef.hostView);
            this.angularRef.destroy();
        });

        return result;
    }

    setValue(value, flags) {
        super.setValue(value, flags);
        if (this.angularRef?.instance && this.angularRef.instance._value !== value) {
            this.angularRef.instance._value = value;
        }
    }

    detach() {
        if (this.angularRef) {
            this.angularRef.destroy();
            this.angularRef = undefined;

            if (this.appRef) {
                this.appRef.detachView(this.angularRef.hostView);
                this.appRef = undefined;
            }
        }
        super.detach();
    }
}

Components.addComponent('pdfUploadMultiple', PdfUploadMultipleFormioComponent);
